import { useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import InputText from '@/trio-ui/InputText';
import { PersonType } from '@/types/api';
import { incorrectUrlMessage } from '@/utils/formsValidation';

const formSchema = yup.object({
  githubUrl: yup.string().url(incorrectUrlMessage),
  trioProfileUrl: yup.string().url(incorrectUrlMessage),
});

export type FormData = yup.Asserts<typeof formSchema>;

type Props = {
  githubUrl?: string;
  trioProfileUrl?: string;
  onSubmit?: (data: Partial<Pick<PersonType, 'githubUrl' | 'trioProfileUrl'>>) => void;
};

const StaffMemberProfessionalExperienceLinksForm = ({
  githubUrl,
  trioProfileUrl,
  onSubmit,
}: Props): JSX.Element => {
  const { values, handleChange, handleSubmit, submitForm, touched, errors, setFieldValue } =
    useFormik<yup.TypeOf<typeof formSchema>>({
      initialValues: {
        githubUrl,
        trioProfileUrl,
      },
      validateOnBlur: false,
      validationSchema: formSchema,
      onSubmit: (data) => {
        onSubmit?.(data as FormData);
      },
    });

  useEffect(() => {
    setFieldValue('githubUrl', githubUrl);
    setFieldValue('trioProfileUrl', trioProfileUrl);
  }, [githubUrl, trioProfileUrl, setFieldValue]);

  const handleBlur = (): void => {
    submitForm();
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="tw-grid tw-grid-cols-2">
        <div className="tw-mb-5">
          <InputText
            // isLabelAboveField
            label="GitHub Link"
            name="githubUrl"
            value={values.githubUrl}
            onChange={handleChange}
            onBlur={handleBlur}
            errorMessage={(touched.githubUrl && errors.githubUrl) || undefined}
          />
        </div>
        <div className="tw-mb-5">
          <InputText
            // isLabelAboveField
            label="Trio Profile Link"
            name="trioProfileUrl"
            value={trioProfileUrl}
            onChange={handleChange}
            onBlur={handleBlur}
            errorMessage={(touched.trioProfileUrl && errors.trioProfileUrl) || undefined}
          />
        </div>
      </div>
      <button className="tw-hidden" type="submit">
        submit
      </button>
    </form>
  );
};

export default StaffMemberProfessionalExperienceLinksForm;
